export * from './attributes/attributes.component';
export * from './entities-management/entities-management.component';
export * from './form-setup/form-setup.component';
export * from './form-setup-view/form-setup-view.component';
